import { Box, BoxProps, ColorOptions, convertHexToRGBA, RadioButton, Spacer, Text } from '@jfs/ui-new'
import { Dimensions, FlatList } from 'react-native'
import { MerchantStatus } from '../../data/static/data'
import { useStores } from '../../data/store'
import {
  Colors,
  extractFirstLetterFromName,
  getDisableState,
  logEvent,
  removeDataFromStorage,
  storeData
} from '../../util/util'

const height = Dimensions.get('screen').height
const midListHeight = 75
export const RenderMidList = ({ merchantList, mobileView, setMidListVisible }: any) => {
  const {
    selectedMid,
    resetSelectedDates,
    updateSelectedMercName,
    updateSelectedMercMid,
    updateselectedMercTid,
    updateSelectedMercMobileNumber,
    updateVpaFromStore,
  } = useStores((store) => ({
    selectedMid: store?.user?.selectedMid,
    resetSelectedDates: store.resetDatesInPaymentTabs,
    updateSelectedMercName: store.settings.metaData.updateSelectedMercName,
    updateSelectedMercMid: store.user.updateSelectedMercMid,
    updateselectedMercTid: store.user.updateSelectedMercTid,
    updateSelectedMercMobileNumber: store.settings.metaData.updateSelectedMercMobileNumber,
    updateVpaFromStore: store.user.updateVpaFromStore,
  }))

  const renderMidItem = ({ item, index }: { item: any; index: number }) => {
    const isSelected = item?.mid === selectedMid
    const isDisabled = getDisableState(item)

    const listItemData = merchantList[index]
    const handleOnPress = (): void => {
      logEvent('item_press', 'mid_selection')
      setMidListVisible(false)
      const regexActive = 'active'
      const isValidMerchant =
        (item.status?.toLowerCase() === regexActive || item.status === MerchantStatus.HotMerchant) &&
        item.userStatus?.toLowerCase() === regexActive
      if (isValidMerchant) {
        resetSelectedDates()
        updateSelectedMercName(listItemData?.businessName)
        updateSelectedMercMid(listItemData?.mid ?? '')
        updateselectedMercTid(listItemData?.tId ?? '')
        updateSelectedMercMobileNumber(listItemData?.contact?.mobile ?? '')
        updateVpaFromStore()
        const midData = {
          mid: listItemData?.mid ?? '',
          tId: listItemData?.tId ?? '',
          businessName: listItemData?.businessName ?? '',
          status: listItemData?.status ?? '',
        }
        storeData('midData', midData)
        removeDataFromStorage('onboardRetryCount')
        window?.localStorage?.setItem('midData', JSON.stringify(midData))
      }
    }
    return (
      <Box
        {...styles.buttonBox}
        key={item?.mid}
        disabled={isDisabled || isSelected}
        bg={isDisabled ? 'ALTO_DISABLED' : 'WHITE'}
        height={midListHeight}
        opacity={isDisabled ? 0.4 : 1}
        testID={'mid-' + item?.mid}
        onPress={() => {
          !isDisabled && handleOnPress()
        }}>
        <Box
          w={40}
          h={40}
          borderRadius={20}
          bg={convertHexToRGBA(Colors.PRIMARY, 8) as ColorOptions}
          justify={'center'}
          align={'center'}>
          <Text
            title={extractFirstLetterFromName(item?.businessName)}
            fontFamily={'JioType-Bold'}
            fontSize={12}
            color={'SECONDARY'}
            lineHeight={16}
            letterSpacing={-0.06}
          />
        </Box>
        <Spacer direction="horizontal" size={16} />
        <Box f={1}>
          <Text
            fontFamily={'JioType-Bold'}
            ellipsizeMode={'tail'}
            fontSize={14}
            numberOfLines={1}
            lineHeight={20}
            letterSpacing={-0.07}
            color={Colors.BLACK_14 as ColorOptions}>
            {item?.businessName ?? ''}
          </Text>
          <Text
            fontFamily={'JioType-Medium'}
            ellipsizeMode={'tail'}
            fontSize={12}
            numberOfLines={1}
            lineHeight={16}
            letterSpacing={-0.07}
            color={'BLACK'}
            opacity={0.65}>
            {item?.mid ?? ''}
          </Text>
        </Box>
        <RadioButton
          checked={selectedMid === item?.mid}
          color={'PRIMARY'}
          size={16}
          onChange={() => {
            !isDisabled && handleOnPress()
          }}
        />
      </Box>
    )
  }

  const boxHeight = height.toString()
  const midLength = merchantList?.length
  const avialContentArea = height >= 300 ? parseInt(boxHeight, 10) - 200 : height - 70
  const overlayHeight = midLength * midListHeight
  const wrapperHeight = avialContentArea > overlayHeight ? overlayHeight : avialContentArea

  return (
    <Box {...styles.midBox(mobileView)} height={wrapperHeight}>
      <FlatList
        data={merchantList}
        extraData={merchantList}
        renderItem={renderMidItem}
        keyExtractor={(item) => item.mid}
        showsVerticalScrollIndicator={true}
        contentContainerStyle={{ flexGrow: 1, paddingHorizontal: 24 }}
      />
    </Box>
  )
}

const styles = {
  midBox: (isMobile = true) =>
  ({
    bg: 'WHITE',
    //maxHeight: isMobile ? undefined : '90%',
    borderRadius: 4,
    minWidth: isMobile ? undefined : 450,
  } as BoxProps),
  buttonBox: {
    flexDirection: 'row',
    bg: 'WHITE',
    //pv: 13,
    align: 'center',
    underlayColor: 'TRANSPARENT',
  } as BoxProps,
}
